import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Importar traduções
import de from './i18n/locales/de.json';
import en from './i18n/locales/en.json';
import pt from './i18n/locales/pt.json';
import es from './i18n/locales/es.json';

const resources = {
  de: { translation: de },  // Alemão (padrão)
  en: { translation: en },  // Inglês Britânico
  pt: { translation: pt },  // Português
  es: { translation: es }   // Espanhol
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'de',  // Alemão como padrão
    lng: 'de',          // Língua inicial: Alemão
    debug: false,
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'selectedLanguage'
    }
  });

export default i18n;
